<template>
	<div class="bigbox cursorstyle">
		<!-- <div class="bannder">
		</div> -->
		
		<p class="title">相关规范</p>
		<!-- 表单 -->
		<div class="tablebox">
			<el-table :data="tableData"  @row-click="openDetails">
				<el-table-column label="标题" align="left">
					<template slot-scope="scope">
						{{scope.row.name}}
						<!-- <div @click="Noticebtn()">
						</div> -->
					</template>
				</el-table-column>
				<el-table-column label="发布时间" align="center" width="130px">
					<template slot-scope="scope">
						<span>{{userObj.dateFormat(scope.row.create_time)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="view_count" label="浏览次数" align="center" width="100px">
				</el-table-column>
<!--				<el-table-column prop="" label="下载" align="center" width="100px">-->
<!--					<template slot-scope="scope">-->
<!--						<div>-->
<!--							<i class="el-icon-upload"></i>-->
<!--						</div>-->
<!--					</template>-->
<!--				</el-table-column>-->
			</el-table>
		</div>
		<div class="fenye">
			<!-- 分页 -->
			<el-pagination background :page-size="5" layout=" prev, pager, next,jumper" :total="this.total_count"
				:current-page="SubmitObj.page_num" @current-change="handleCurrentChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		GetlistinformationInterface
	} from "@/api/ApplicationManagement.js"
	export default {
		data() {
			return {

				tableData: [],
				// 总条数
				total_count: null,
				// 总页数
				total_page: null,
				SubmitObj: {
					// 页数
					page_num: 1,
				}
			}
		},
		mounted() {
			this.Getlistinformation("1")
		},
		methods: {
			Noticebtn() {
				this.$router.push('./NoticeDetails')
			},
			openDetails(row){
				// this.AchievementsDetails({path:'/NoticeDetails',item:row})
				this.$router.push({path:'./NoticeDetails',query:{ids:row.id,type:'standard'}})
			},
			async Getlistinformation(val) {
				let obj
				if (val == '1') {
					obj = {
						// 1:通知公告 2:办事指南 3:相关规范 4:常用表格
						type: '3'
					}
				}else{
					obj = {
						// 1:通知公告 2:办事指南 3:相关规范 4:常用表格
						type: '3',
						// 条数
						page_num:this.SubmitObj.page_num
					}
				}
				
				let res = await GetlistinformationInterface(obj)
				if (res.code == "00000") {
					this.tableData = res.data.result
					this.total_count = res.data.total_count
				}
			},
			// 分页
			handleCurrentChange(val) {
				this.SubmitObj.page_num = val
				this.Getlistinformation("2")
			},
		}
	}
</script>

<style scoped="scoped" lang="less">
	.bigbox {
		width: 63vw;
		margin: 0 auto;
		// border: 1px red solid;
	}

	.bannder {
		width: 100%;
		height: 326px;
		background: #D8D8D8;
		margin: 0 auto;
		margin-top: 14px;
	}

	.nav {
		margin-top: 14px;
		font-size: 16px;
		color: #333333;
	}

	.title {
		font-size: 18px;
		font-weight: bold;
		color: #333333;
		margin-top: 10px;
	}



	// 按钮
	.btn1 {
		width: 56px;
		height: 28px;
		background: #094AAE;
		border-radius: 5px;
		color: #FFFFFF;
		font-size: 14px;
		text-align: center;

	}

	.btn2 {
		width: 82px;
		height: 28px;
		background: #8F5400;
		border-radius: 5px;
		color: #FFFFFF;
		font-size: 14px;
		text-align: center;
		margin-left: 10px;
	}

	.btn3 {
		width: 82px;
		height: 28px;
		background: #4D8F00;
		border-radius: 5px;
		color: #FFFFFF;
		font-size: 14px;
		text-align: center;
		margin-left: 10px;
	}


	/* table */
	.tablebox {
		height: 40vh;
		margin: 0 auto;
		margin-top: 20px;

	}

	/deep/.el-table__header th {
		padding: 0;
		line-height: 40px;
		height: 40px;
		// background: #D8D8D8;
		font-weight: bold;
		color: #333333;
		font-size: 16px;

	}

	/deep/ .el-table__body td {
		padding: 0;
		height: 40px;
		line-height: 40px;
		color: #666666;
		font-size: 14px;
		border-bottom: 1px #E5E5E5 dashed;
	}

	/deep/.is-scrolling-none {
		// border-bottom: 1px #E5E5E5 dashed;
	}

	/deep/.el-table::before {
		height: 0px;
	}


	/deep/.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px #E5E5E5 dashed;

	}

	/deep/.el-table--border th.gutter:last-of-type {

		border-bottom: 1px solid red;

	}

	/deep/tbody tr:hover>td {
		color: #EA6911;
		background: #FFFFFF !important;
	}

	.fenye {
		float: right;
		margin-right: 40px;
	}

	.el-pagination {
		margin-top: 10px;
		margin-bottom: 10px;
	}

	/deep/.el-pagination .el-select .el-input .el-input__inner {
		width: 100px !important;
		margin: 0 5px !important;
	}

	/deep/.el-pagination__editor.el-input .el-input__inner {
		width: 50px;
	}

	i {
		font-size: 25px;
	}


  /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
    cursor:pointer !important;
  }
</style>
